import styled from 'styled-components'
import { maxSize } from 'utils/constants/breakpoint'

export const Content = styled.div`
  padding: 1rem 0.8rem;
`

export const Row = styled.div`
  display: grid;
  column-gap: 2.8rem;
  row-gap: 1.8rem;
  margin-bottom: 1.8rem;
  grid-template-columns: 1fr 1fr;
  @media ${maxSize.md} {
    grid-template-columns: 1fr;
  }
`

export const Column = styled.div`
  display: flex;
  flex-direction: column;
`
